// Per il dev
// var STRIPE_PUBLISHABLE_KEY = 'pk_test_PO6MvEvM6bq3JxU32t6PMe88';

// Per la prod
var STRIPE_PUBLISHABLE_KEY = 'pk_live_b0B2wvrh1tBMqtet8Ny2BPKB';
var STRIPE_JS_URL = 'https://js.stripe.com/v3/';

// Stripe.js pesa circa 800 KB: lo carichiamo solo quando qualcuno si avvicina
// al bottone Premium, invece che su ogni pagina in cui il bottone compare.
var stripePromise = null;

var loadStripe = function() {
  if (stripePromise) {
    return stripePromise;
  }

  stripePromise = new Promise(function(resolve, reject) {
    var script = document.createElement('script');
    script.src = STRIPE_JS_URL;
    script.onload = function() {
      resolve(window.Stripe(STRIPE_PUBLISHABLE_KEY));
    };
    script.onerror = function() {
      stripePromise = null;
      reject(new Error('Stripe.js non disponibile'));
    };
    document.head.appendChild(script);
  });

  return stripePromise;
};

// If a fetch error occurs, log it to the console
var handleFetchResult = function(result) {
  if (!result.ok) {
    return result.json().then(function(json) {
      if (json.error && json.error.message) {
        throw new Error(result.url + ' ' + result.status + ' ' + json.error.message);
      }
    });
  }
  return result.json();
};

// Create a Checkout Session
var createCheckoutSession = function() {
  var AUTH_TOKEN = document.querySelector('meta[name=csrf-token]').content;
  return fetch("/billing", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      authenticity_token: AUTH_TOKEN
    })
  }).then(handleFetchResult);
};

// Handle any errors returned from Checkout
var handleResult = function(result) {
  if (result.error) {
    var displayError = document.getElementById("error-message");
    displayError.textContent = result.error.message;
  }
};

function setupStripeButton(checkoutEl){
  // Hover e focus anticipano il download, cosi il click non aspetta Stripe.js
  checkoutEl.addEventListener("pointerenter", loadStripe, { once: true });
  checkoutEl.addEventListener("focus", loadStripe, { once: true });

  checkoutEl.addEventListener("click", function(evt) {
    Promise.all([loadStripe(), createCheckoutSession()]).then(function(values) {
      var stripe = values[0];
      var data = values[1];
      // Call Stripe.js method to redirect to the new Checkout page
      stripe
        .redirectToCheckout({
          sessionId: data.sessionId
        })
        .then(handleResult);
    });
  });
}

document.addEventListener("DOMContentLoaded", function() {
  var checkoutEls = document.getElementsByClassName("js-checkout")// document.getElementById("checkout")
  for (let i = 0; i < checkoutEls.length; i++) {
    let el = checkoutEls[i]
    setupStripeButton(el)
  }
})
